import { RouteConfig } from 'vue-router';

import { ModuleName } from '@/enums/moduleName.enum';
import store from '@/store/store';

export const documentAssessmentSummarryRoute: RouteConfig = {
  path: 'assessment-summary',
  name: 'documentAssessmentSummary',
  component: () =>
    import(/* webpackChunkName: "DocumentAssesmentSummary" */ '@/views/mainRoute/document/AssessmentSummary.vue'),
  meta: { breadcrumb: { title: 'Wyniki oceny' } },
  beforeEnter: (to, from, next) => {
    const documentId = parseInt(to.params.documentId);
    store.commit('documentIndex/setId', documentId);
    store.dispatch('documentIndex/get').then(documentIndex => {
      store
        .dispatch('status/list', {
          ids: [...(documentIndex.previousStatuses || []), documentIndex.statusId],
          module: ModuleName.assessment
        })
        .then(() => {
          const statuses: any[] = (store.state as any).status.list;
          const statusIds = statuses.map(status => status.id);
          const stageIds = statuses.map(status => status.stage.id);
          Promise.all([
            store.dispatch('criterion/list', { statusIds, count: -1, order: 'order', desc: false }).then(criterions => {
              const missingStageIds = statuses
                .filter(status => !criterions.list.some((criterion: any) => criterion.status.id === status.id))
                .map(status => status.stage.id);
              if (missingStageIds.length) {
                return store.dispatch('criterion/listAppend', { stageIds: missingStageIds });
              }
            }),
            store.dispatch('assessment/list', { stageIds, documentId })
          ]).then(() => next());
        });
    });
  }
};
